import {
  STORE as onboardingStepsStore,
  GET_CARD_REQUEST,
} from "@/store/modules/onboardingSteps/onboardingSteps.types";
import store from '@/store/index'

export default async function hasCardRequestInReview({ next }) {

    await store.dispatch(`${onboardingStepsStore}/getProvisionalCards`);

    const cardRequest = store.getters[`${onboardingStepsStore}/${GET_CARD_REQUEST}`];

    if(cardRequest && (cardRequest.status === 'IN_REVIEW' || cardRequest.status === 'PENDING_WEBHOOK')) {
      return next();
    }

    return next('/wallet');
}
